import script from "./pageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./pageHeader.vue?vue&type=script&setup=true&lang=js"

import "./pageHeader.vue?vue&type=style&index=0&id=b1418eb6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1418eb6"]])

export default __exports__